import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { renderIf } from '@zola-helpers/client';

import Loader from '../../../common/ui/Loader';

import './StoriesSlides.less';

const StoriesSlides = ({ stories, currentIndex, setSlideRefs, assetIsReady }) => (
  <div className="zostories__slides">
    {stories
      .filter((story, i) => i <= currentIndex + 1) // Only load current slide + 1 for performance
      .map((story, i) => (
        <div className={cx('zostories__slide', { 'zostories__slide--isCurrent': i === currentIndex })} key={i}>
          {renderIf(story.type === 'video',
            () => (
              <video muted playsInline autoPlay preload="auto" ref={ref => setSlideRefs(ref, i)}>
                <source src={story.url} type="video/mp4" />
                Sorry, your browser doesn&apos;t support embedded videos.
              </video>
            ),
            () => <img src={story.url} alt={story.description} ref={ref => setSlideRefs(ref, i)} />
          )} {/* eslint-disable-line function-paren-newline */}
          {renderIf(i === currentIndex && !assetIsReady, () => <Loader />)}
        </div>
      ))
    }
  </div>
);

StoriesSlides.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentIndex: PropTypes.number.isRequired,
  setSlideRefs: PropTypes.func.isRequired,
  assetIsReady: PropTypes.bool.isRequired,
};

export default StoriesSlides;



// WEBPACK FOOTER //
// ./src/components/onboard/Stories/StoriesSlides/StoriesSlides.jsx